// extracted by mini-css-extract-plugin
export default {"loaderContainer":"App_loaderContainer__FthOV"};